import config from "../configurations/config";
import { COMMA, EDIT, EDIT_SALESFORCE_MAPPING, EMPTY } from "./Constants";

export function ValidateEmail(mail) {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }
export function getLastIndex(props){
    var path= props.history.location.pathname.split("/");
    var integrationAccountId= path[3];
  return integrationAccountId;
}
export function  logout(){
    sessionStorage.clear();
    window.location.href = config.auth.URL+"logout";
  };
export function doNothing(){

}
export function getFirstEmail(emails){
  let arr=[]
  if((emails).length>1){
    if(emails.includes(COMMA)){
   arr=emails.split(COMMA)
   return arr[0];
  }
   else return emails

}
}

export function getEmailList(emailList1){
  let arr=[]
 if(emailList1 &&(emailList1).length>1){
      if(emailList1.includes(COMMA)){
     arr= emailList1.split(COMMA)}
     else arr=[emailList1]
  }
  return arr;
}
export function getName(name){
  var returnValue =EMPTY;
  switch (name) {
    case EDIT_SALESFORCE_MAPPING:
      returnValue = "Salesforce Mapping";
      break;
    default:
      returnValue = name;
  }
returnValue =returnValue.replace(EDIT, EMPTY)
 return returnValue
}